Auth = require 'db/auth'
BoardsSidebarSectionView = require 'views/boards-sidebar/boards-sidebar-section-view'
ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
SidebarState = require 'view-models/sidebar-state'
_ = require 'underscore'
l = require 'lib/localize'
ninvoke = require 'lib/util/ninvoke'
ApiError = require 'network/api-error'

module.exports = class BoardsSidebarRecentSectionView extends BoardsSidebarSectionView
  initialize: ->
    super

    @listenTo SidebarState, 'change:idRecentBoards', ->
      @debouncedRenderBoards()

    @listenTo @model.boardStarList, 'add remove reset', ->
      @debouncedRenderBoards()

    @_idBoardsFetching = []

  sectionId: -> "recent-boards"

  sectionName: -> "Recent Boards"

  showOrgName: -> true

  isRecent: -> true

  getBoards: ->
    me = Auth.me()
    _.chain SidebarState.getRecentBoards()
    .difference @model.boardStarList.getBoardIds()
    .tap (idBoards) => @fetchUnknownBoards(idBoards)
    .map (idBoard) => @modelCache.get('Board', idBoard)
    .compact()
    .filter (board) => board.isViewableBy(me)
    .take 7
    .value()

  fetchUnknownBoards: (idBoards) ->
    idBoardsMissing = _.chain idBoards
    .difference @_idBoardsFetching
    .reject (idBoard) => @modelCache.get('Board', idBoard)?
    .value()

    return if idBoardsMissing.length == 0

    @_idBoardsFetching = @_idBoardsFetching.concat(idBoardsMissing)

    boards = idBoardsMissing.map (idBoard) =>
      ModelLoader.loadBoardData idBoard, Payloads.boardMinimal
      .catch ApiError.NotFound, ApiError.Unauthorized, ->
        SidebarState.pullBoard(idBoard)

    Promise.all boards
    .then =>
      @_idBoardsFetching = _.difference @_idBoardsFetching, idBoardsMissing
      @debouncedRenderBoards()
      return
    .done()

  getHeaderInfo: ->
    {
      title: l('board section title.recent boards')
      iconClass: 'clock'
    }



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-recent-section-view.coffee